import { CircularProgress } from '@mui/material'
import Button, { ButtonProps } from '@mui/material/Button'

interface ZButtonProps extends ButtonProps {
  loading?: boolean
}

const ZButton = (props: ZButtonProps) => {
  const { loading, disabled, sx, ...rest } = props

  return (
    <Button
      variant="contained"
      size="large"
      color="primary"
      disabled={disabled || loading}
      sx={{
        // Loading is not "not yet clickable": the button is disabled only to
        // stop a second tap, so it keeps full strength (the theme's 0.3 dim
        // applies to a genuinely disabled button) and shows a spinner in the
        // ground colour so it reads against the solid primary fill.
        ...(loading ? { '&.Mui-disabled': { opacity: 1 } } : {}),
        ...(sx as object),
      }}
      {...rest}
      fullWidth
    >
      {props?.loading ? (
        <CircularProgress size={26} sx={{ color: 'background.default' }} />
      ) : (
        props.children
      )}
    </Button>
  )
}

export default ZButton
